// z25 (Diego, 20-oct-2026): cuando el vendedor le pide a la IA ajustar consumos («la casa estaba en construcción; a partir
// de junio ya viven…»), la propuesta se ve como una tabla corta ANTES/DESPUÉS por periodo, con el porqué y los supuestos
// de la estimación. Se aplica junto con el resto de la propuesta (botón «Aplicar»): una casilla para todo el ajuste.
import { numero } from '@cotizador/compartido';
import type { AjusteConsumosPropuesto } from '@cotizador/compartido';

export function TablaAjusteConsumos({ ajuste, elegido, alCambiar }: { ajuste: AjusteConsumosPropuesto; elegido: boolean; alCambiar: (v: boolean) => void }) {
  const antes = ajuste.meses.reduce((s, m) => s + m.antes_kwh, 0);
  const despues = ajuste.meses.reduce((s, m) => s + m.despues_kwh, 0);
  const n = ajuste.meses.length;
  return (
    <div className="ajuste-consumos">
      <label className="propuesta__cambio">
        <input type="checkbox" checked={elegido} onChange={(e) => alCambiar(e.target.checked)} />
        <span className="propuesta__ruta">
          Ajustar el consumo de {n === 1 ? '1 periodo' : `${n} periodos`} del medidor {ajuste.medidor}
        </span>
        <span className="propuesta__valores">{ajuste.justificacion}</span>
      </label>
      <table className="ajuste-consumos__tabla">
        <caption className="ajuste-consumos__titulo">Consumo por periodo, en kWh</caption>
        <thead>
          <tr>
            <th scope="col">Periodo</th>
            <th scope="col">Antes (recibo)</th>
            <th scope="col">Después</th>
          </tr>
        </thead>
        <tbody>
          {ajuste.meses.map((m) => (
            <tr key={m.indice}>
              <th scope="row">{m.etiqueta}</th>
              <td>
                <del>{numero(m.antes_kwh)}</del>
              </td>
              <td>
                <ins>{numero(m.despues_kwh)}</ins>
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th scope="row">Total</th>
            <td>{numero(antes)}</td>
            <td>{numero(despues)}</td>
          </tr>
        </tfoot>
      </table>
      {ajuste.supuestos.length > 0 && (
        <ul className="ajuste-consumos__supuestos" aria-label="Supuestos de la estimación">
          {ajuste.supuestos.map((s, i) => (
            <li key={i}>{s}</li>
          ))}
        </ul>
      )}
      <p className="ajuste-consumos__nota">Al aplicarlo, cada periodo guarda el consumo del recibo y deja de usar lo que cobró CFE (ya no es el cobro de ese consumo). Luego se recalculan las opciones.</p>
    </div>
  );
}
